// extracted by mini-css-extract-plugin
export const tabSection = "tabs-module--tabSection--2GFer";
export const sectionContainer = "tabs-module--sectionContainer--2GnJR";
export const containerInner = "tabs-module--containerInner--Oh-gW";
export const textWrap = "tabs-module--textWrap--15Ykh";
export const sectionBackground = "tabs-module--sectionBackground--4V_im";
export const tabWrap = "tabs-module--tabWrap--9Y6l8";
export const tabLabelWrap = "tabs-module--tabLabelWrap--2rui2";
export const tabLabel = "tabs-module--tabLabel--DjzTU";
export const tabLabel__active = "tabs-module--tabLabel__active--1BPRy";
export const mobileTabSelect = "tabs-module--mobileTabSelect--3FHga";
export const mobileTabValue = "tabs-module--mobileTabValue--1fe4r";
export const mobileTabOptions = "tabs-module--mobileTabOptions--2m5Rw";
export const mobileTabOptions__active = "tabs-module--mobileTabOptions__active--3YNqh";
export const tabOption = "tabs-module--tabOption--1IiQZ";
export const tabContentWrap = "tabs-module--tabContentWrap--1NYTF";
export const tabItem = "tabs-module--tabItem--3_Hzi";
export const tabItem__active = "tabs-module--tabItem__active--2poyj";
export const accordionWrap = "tabs-module--accordionWrap--1Rlex";
export const accordionItem = "tabs-module--accordionItem--p63QI";
export const accordionLabel = "tabs-module--accordionLabel--2SRT3";
export const priceLabel = "tabs-module--priceLabel--UcJi9";
export const accordionIconWrap = "tabs-module--accordionIconWrap--2jFah";
export const accordionIcon = "tabs-module--accordionIcon--1RWZF";
export const accordionContent = "tabs-module--accordionContent--a6rrE";
export const accordionOpen = "tabs-module--accordionOpen--isbjm";
export const contentWrap = "tabs-module--contentWrap--3P-gN";
export const contentImage = "tabs-module--contentImage--8JI3q";
export const richtext = "tabs-module--richtext--OlVKL";